import { mapActions, mapGetters } from 'vuex';
import ScheduleStatus from './ScheduleStatus';
export default {
  name: 'Schedule',
  props: {
    projectId: {
      type: Number,
      required: true
    }
  },
  created() {
    this.fetchSchedule({
      projectID: this.projectId
    });
  },
  methods: {
    ...mapActions('schedule', ['fetchSchedule'])
  },
  computed: {
    ...mapGetters('schedule', ['project', 'loading', 'errors'])
  },
  components: {
    ScheduleStatus
  }
};